<template>
  <listTemplate :class="'height__100vh'">
    <template #header>
      <header-template>
        <template #filterByStatus>
          <hc-maybay-state-header
            :state="advanceSearchForm.state"
            :pageTitle="pageTitle"
            :stateOptions="stateOptions"
            @doFilter="stateChanged"
          />
        </template>
      </header-template>
    </template>

    <template #view>
      <div class="view">
      <!-- <div class="view view-with__extendBar"> -->
        <div class="list-docs wrapper-content__main">
          <!--Header-->
          <sub-header>
            <template #content>
              <div class="leftSection flex-row flex__left">
                <el-button
                  size="medium"
                  type="success"
                  class="createNew"
                  v-if="advanceSearchForm.hcFlowId !== null"
                  @click="openCreateDialog()"
                >
                  <div class="flex-row flex__center">
                    <i class="fas fa-plus-circle font-size__large"></i>
                    <span>&nbsp;&nbsp;THÊM MỚI</span>
                  </div>
                </el-button>
              </div>

              <searchTemplate
                :keyword="keyword"
                :isDisableAdvanceSearch="true"
                @simpleSearch="simpleSearch"
              >
              </searchTemplate>
            </template>
          </sub-header>

          <!--Content-->
          <div class="list">
            <!-- header-title -->
            <div class="header-title flex-row flex__between margin-bottom-10">
              <div class="leftSection flex-row flex__left">
                <div class="theTitle theTitle__lv5 flex-row flex__center">
                  STT
                </div>
                <div
                  class="theTitle theTitle__lv1 flex-row flex__left padding-left-10"
                >
                  Tiêu đề
                </div>
              </div>
              <div class="rightSection flex-row flex__right">
                <div
                  class="theTitle theTitle__lv3 flex-row flex__around margin-right-10"
                >
                  Trạng thái
                </div>
                <div
                  class="theTitle theTitle__lv3 flex-row flex__right padding-right-10"
                >
                  Phòng họp
                </div>
                <div
                  class="theTitle theTitle__lv3 flex-row flex__right padding-right-10"
                >
                  Người phê duyệt
                </div>
                <div
                  class="theTitle theTitle__lv3 flex-row flex__right padding-right-10"
                  @click="doSort('createTime')"
                >
                  Ngày tạo
                  <sort-caret
                    :order="order"
                    :sort="sort"
                    :field="'createTime'"
                  />
                </div>
              </div>
            </div>
            <!-- list-data -->
            <VuePerfectScrollbar
              class="scroll-area"
              :settings="perfectScrollbarSetting"
              infinite-wrapper
            >
              <div class="list-docs">
                <div
                  v-for="(item, $itemIndex) in items"
                  v-bind:key="$itemIndex"
                  class="item flex-row flex__between"
                  @click.stop="viewDetail(item)"
                >
                  <div class="leftSection flex-row flex__left clickable">
                    <div class="theTitle__lv5">
                      <div class="flex-row flex__left">
                        <div class="section-check">
                          <span class="stt flex-row flex__center">{{
                            $itemIndex + 1
                          }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="theTitle__lv1 margin-right-10">
                      <div class="title-docs flex-col flex__left">
                        <div class="tt_1 clickable">{{ item.caseTitle }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="rightSection flex-row flex__right">
                    <div
                      class="theTitle__lv3 flex-row flex__around padding-left-10 font-size__small"
                    >
                      <hc-maybay-state :state="item.currentStateCode" />
                    </div>
                    <div
                      class="theTitle__lv3 flex-row flex__right padding-right-10 font-size__small"
                    >
                      {{ item.meetingRoomName || "Chưa có phòng họp" }}
                    </div>
                    <div
                      class="theTitle__lv3 flex-row flex__right padding-right-10 font-size__small"
                    >
                      {{ item.approveUserName || "Chưa có người duyệt" }}
                    </div>
                    <div
                      class="theTitle__lv3 flex-row flex__right padding-right-10 font-size__small"
                    >
                      <div class="flex__between">
                        <span>{{
                          item.createTime | dateFormatter({ nullValue: "-" })
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <infinite-loading
                  ref="infiniteLoading"
                  spinner="spiral"
                  @infinite="infiniteHandler"
                  force-use-infinite-wrapper=".el-table__body-wrapper"
                >
                  <div slot="no-more"></div>
                  <div slot="no-results">Không có dữ liệu</div>
                </infinite-loading>
              </div>
            </VuePerfectScrollbar>
          </div>
        </div>

        <slot name="extend"></slot>
      </div>
    </template>
  </listTemplate>
</template>
<script type="text/javascript">
import listTemplate from "../../common/list";
import searchTemplate from "../../common/search.vue";
import headerTemplate from "../../../components/header/main-header.vue";
import utils from "../../../services/utils";
import hanhchinhService from "../../../services/hanhchinhService";
import constants from "../../../constants";
import dateUtils from "../../../dateUtils";
import hcMasterCaseRequestViewService from "../../../services/hanhchinh/hcMasterCaseRequestViewService";
import SortCaret from "../../doc-out/SortCaret";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import dateFormatter from "../../../filters/dateFormatter";
import goBackMixin from "../../../mixins/goBackMixin";
import h from "../../../services/h";
import hanhChinhUtils from "../../../services/hanhChinhUtils";
import hcFlowService from "../../../services/hcFlowService";
import SubHeader from "../../../components/main/sub-header";
import HcMaybayStateHeader from "../khachsan/hc-maybay-state-header";
import HcMaybayState from "../khachsan/hc-maybay-state";
// import userDeptRoleViewService from "../../../services/userDeptRoleViewService";

export default {
  name: "hc-base-index",
  mixins: [goBackMixin],
  props: ["pageTitle", "flowCode", "defaultStateOptions"],
  components: {
    HcMaybayState,
    HcMaybayStateHeader,
    SubHeader,
    SortCaret,
    listTemplate,
    headerTemplate,
    searchTemplate,
    VuePerfectScrollbar,
  },

  filters: { dateFormatter },

  data() {
    return {
      advanceSearchForm: {
        keyword: null,
        // filterStatus: null,
        startTime: null,
        endTime: null,
        hcFlowId: null,
        state: null,
      },
      keyword: null,
      items: [],
      page: 0,
      size: 10,
      sort: "updateTime",
      order: "desc",
      stateOptions: null,

      hcFlowsWhichCanApprove: null,
    };
  },

  watch: {},

  computed: {
    isAbleToApprove() {
      return this.hcFlowsWhichCanApprove && this.hcFlowsWhichCanApprove.length;
    },
  },

  async created() {
    this.initQuery();
    this.initStateOptions();
    await this.getProcedureInformation();
    this.registerEventBusForMaster((event) => {
      console.log("registerEventBusForMaster");
      this.doSearch();
    });
    await this.loadHcFlowWhichUserCanApprove();
  },

  destroyed() {
    this.unregisterEventBusForMaster();
  },

  methods: {
    openReportDialog() {
      this.$emit("openReportDialog");
    },

    loadHcFlowWhichUserCanApprove() {
      return hcFlowService
        .findAllHcCaseCommonFlowWhichUserCanApprove(this.flowCode)
        .then((response) => (this.hcFlowsWhichCanApprove = response.data));
    },

    initStateOptions() {
      this.stateOptions =
        this.defaultStateOptions ||
        h.collect(
          [
            "-1",
            constants.HC_STATE.STATE_CODE.MAY_BAY.DA_DANG_KY,
            constants.HC_STATE.STATE_CODE.MAY_BAY.CHO_PHE_DUYET,
            constants.HC_STATE.STATE_CODE.MAY_BAY.DA_PHE_DUYET,
            constants.HC_STATE.STATE_CODE.MAY_BAY.TU_CHOI,
            constants.HC_STATE.STATE_CODE.MAY_BAY.HUY,
          ],
          (state) => {
            return {
              id: state,
              name:
                state === "-1"
                  ? "Tất cả"
                  : hanhChinhUtils.getMayBayStateLabel(state),
            };
          }
        );
    },

    stateChanged(event) {
      this.advanceSearchForm.state = event.state;
      this.doSearch();
    },

    initQuery() {
      let query = this.$route.query;
      this.advanceSearchForm.keyword = utils.getParamFromQuery(
        query,
        "keyword"
      );
      this.advanceSearchForm.state =
        utils.getParamFromQuery(query, "state") || "-1";
      this.keyword = this.advanceSearchForm.keyword;
      this.initTimeRange();
    },

    initTimeRange() {
      utils.timeRangeChanged(
        dateUtils.getDatesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.LAST_YEAR
        ),
        (from_, to_) => {
          this.advanceSearchForm.startTime = from_;
          this.advanceSearchForm.endTime = to_;
        }
      );
    },

    getProcedureInformation() {
      return hanhchinhService
        .getProcedureInformation(this.flowCode)
        .then((response) => {
          if (response.data.hcFlow !== null) {
            this.advanceSearchForm.hcFlowId = response.data.hcFlow.id;
          }
        });
    },

    simpleSearch(keyword) {
      this.searchKey = this.advanceSearchForm.keyword = keyword;
      this.doSearch();
    },

    buildRouteQuery() {
      return utils.merge(
        { sort: this.sort, order: this.order },
        this.advanceSearchForm
      );
    },

    convertToSearchForm() {
      return {
        key: this.advanceSearchForm.keyword,
        // status: this.advanceSearchForm.filterStatus,
        hcFlowId: this.advanceSearchForm.hcFlowId,
        startTime: this.advanceSearchForm.startTime,
        endTime: this.advanceSearchForm.endTime,
        flowCode: this.flowCode,
        state:
          this.advanceSearchForm.state === "-1"
            ? null
            : this.advanceSearchForm.state ===
                constants.HC_STATE.STATE_CODE.MAY_BAY.DA_DANG_KY ||
              this.advanceSearchForm.state ===
                constants.HC_STATE.STATE_CODE.MAY_BAY.CHO_PHE_DUYET
            ? constants.HC_STATE.STATE_CODE.MAY_BAY.CHO_PHE_DUYET
            : this.advanceSearchForm.state ===
                constants.HC_STATE.STATE_CODE.MAY_BAY.TU_CHOI
            ? constants.HC_STATE.STATE_CODE.MAY_BAY.TU_CHOI
            : this.advanceSearchForm.state,
      };
    },

    doSearch() {
      this.$router.replace({
        name: this.$route.name,
        params: this.$route.params,
        query: this.buildRouteQuery(),
      });
      this.items = [];
      this.page = 0;
      this.$nextTick(() => {
        this.$refs.infiniteLoading &&
          this.$refs.infiniteLoading.stateChanger.reset();
      });
    },

    list() {
      let pageable = {
        page: this.page,
        size: this.size,
        sort: [this.sort, this.order].join(","),
      };
      return hcMasterCaseRequestViewService
        .findAll(this.convertToSearchForm(), pageable)
        .then((response) => {
          let items = response.data || [];
          // console.log(items);
          // userDeptRoleViewService.findAllByIdIn(items.map(item => item.))
          if(this.advanceSearchForm.state === constants.HC_STATE.STATE_CODE.MAY_BAY.DA_DANG_KY) {
            items = items.filter(item => item.requestUserId === this.$store.getters.user.id);
          }
          items && this.items.push(...items);
          return items;
        });
    },

    openCreateDialog() {
      this.$emit("openCreateDialog");
    },

    infiniteHandler($state) {
      this.list().then((items) => {
        this.page += 1;
        items && items.length ? $state.loaded() : $state.complete();
      });
    },

    // sort
    doSort(sort) {
      let order =
        sort === this.sort ? (this.order === "asc" ? "desc" : "asc") : "asc";
      this.sort = sort;
      this.order = order;
      this.doSearch();
    },

    // xem chi tiet
    viewDetail(e) {
      let caseMasterId = e.caseMasterId;
      this.$emit("viewDetail", { caseMasterId: caseMasterId });
    },
  },
};
</script>

<style type="text/css" scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/khachsan/hc-base-index.vue